// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__180j0","col":"styles_col__ntBUJ"};